import React, { useEffect, useImperativeHandle, useState } from "react";
import { ThreedPopupRefProp } from "../../../common/types";
import Modal from "../Modal";
import { Button } from "../Elements";
import { useDispatch } from "react-redux";
import { ThunkDispatch } from "redux-thunk";


declare global {
    interface Window {
        attachEvent: any;
    }
}

type Props = {
    onPaymentComplete: (paymentResultParameters: string) => void
}

const ThreedPopup = React.forwardRef<ThreedPopupRefProp, Props>((props: Props, ref) => {

    const[paymentHtml, setPaymentHtml ]= useState("");

    useImperativeHandle(ref, () => ({

        postPayment(paymentParameters) {
            setPaymentHtml(paymentParameters);
            setIsVisible(true);
        }
    }));

    const [isVisible, setIsVisible] = useState(false);

    const { } = props;

    const onloadIframe = (event: any) => {


    }


    useEffect(() => {


        if (window.addEventListener) {
            window.addEventListener("message", messageReceived, false);
        } else {
            window.attachEvent("onmessage", messageReceived);
        }

        return () => {
            window.removeEventListener('onmessage', messageReceived);
        }

    }, []);

    function messageReceived(message: any) {

        var paymentResult = message.data;
        window.removeEventListener('onmessage', messageReceived);

        try {
            JSON.parse(paymentResult);
            setIsVisible(false);
            props.onPaymentComplete(paymentResult);
        } catch (e) {
            return false;
        }



    }
    const closeModal = () => {
        setIsVisible(false);
    }

    const gatewayUrl = window.location.origin + "/odeme-yonlendirme";

 


    return (
        <Modal openModal={isVisible} setOpenModal={setIsVisible} dialogclassName="max-w-lg" >
            <div>
                <div className="sm:flex sm:items-start">
                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full">
                        <h3 className="text-md leading-6 font-medium text-gray-900">
                            {"Ödeme Sayfası"}
                        </h3>

                        <div className="w-full mb-5 min-h-[500px]" >
                            <iframe id="payment-iframe" className="w-full mb-5 min-h-[550px]"
                            srcDoc={paymentHtml}
                             onLoad={(event) => onloadIframe(event)} width={"100%"} height={"100%"}></iframe>
                        </div>
                    </div>
                </div>
                <div className="mt-5 mt-4 flex justify-end space-x-2">
                    <Button
                        color="gray"
                        hover="gray"
                        size="xs"
                        callback={() => closeModal()}
                    >
                        {"İptal"}
                    </Button>
                </div>
            </div>
        </Modal>
    );
})

export default ThreedPopup;